import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "frame-35" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "frame-36" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-wrapper-18" }, "Opérations simplifiées"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-wrapper-19" }, " Automatisez les tâches répétitives et concentrez-vous sur ce que vous aimez le plus : créer de magnifiques arrangements. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['property-default-wrapper', _ctx.property1, _ctx.className])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "heart-handshake",
        alt: "Heart handshake",
        src: _ctx.heartHandshake
      }, null, 8, _hoisted_2),
      _hoisted_3
    ])
  ], 2))
}